import React from "react";
import { HelpCircle } from "lucide-react";

export const AjutorButton = ({ file }) => (
  <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
    <a
      href={`/${file}`}
      download
      data-testid="ajutor-pdf-button"
      style={{
        fontFamily: "Arial, sans-serif", fontSize: 12, fontWeight: "bold",
        background: "#cc0000", color: "#fff", border: "1px solid #cc0000",
        padding: "6px 12px", borderRadius: 4, textDecoration: "none",
        display: "inline-flex", alignItems: "center", gap: 6,
      }}
    >
      <HelpCircle style={{ width: 15, height: 15 }} /> Ajutor (PDF)
    </a>
  </div>
);
